import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { WalletLinkConnector } from "@web3-react/walletlink-connector";

import CoinbaseLogo from "../assets/walletImages/coinbaseWalletIcon.svg";
import MetaMaskLogo from "../assets/walletImages/metamask.png";
import WalletConnectLogo from "../assets/walletImages/walletConnectIcon.svg";
import { ALL_SUPPORTED_CHAIN_IDS, SupportedChainId } from "../constants/chains";

const RPC_URLS: { [chainId: number]: string } = {
	1: process.env.REACT_APP_RPC_URL_1 as string,
	3: process.env.REACT_APP_RPC_URL_3 as string,
	4: process.env.REACT_APP_RPC_URL_4 as string,
	42: process.env.REACT_APP_RPC_URL_42 as string,
	1337: process.env.REACT_APP_RPC_URL_1337 as string,
}

const INFURA_KEY = process.env.REACT_APP_INFURA_KEY

if (typeof INFURA_KEY === 'undefined') {
	throw new Error(`REACT_APP_INFURA_KEY must be a defined environment variable`)
}

export const NETWORK_URLS: { [key in SupportedChainId]: string } = {
	[SupportedChainId.MAINNET]: RPC_URLS[SupportedChainId.MAINNET] + INFURA_KEY,
	[SupportedChainId.RINKEBY]: RPC_URLS[SupportedChainId.RINKEBY] + INFURA_KEY,
	[SupportedChainId.ROPSTEN]: RPC_URLS[SupportedChainId.ROPSTEN] + INFURA_KEY,
	[SupportedChainId.KOVAN]: RPC_URLS[SupportedChainId.KOVAN] + INFURA_KEY,
	[SupportedChainId.LOCALHOST]:
		RPC_URLS[SupportedChainId.LOCALHOST] + INFURA_KEY,
}

export enum ConnectorNames {
	Injected = 'Injected',
	WalletConnect = 'WalletConnect',
	Coinbase = 'Coinbase',
}

export const injected = new InjectedConnector({
	supportedChainIds: ALL_SUPPORTED_CHAIN_IDS,
})

export const walletconnect = new WalletConnectConnector({
	supportedChainIds: ALL_SUPPORTED_CHAIN_IDS,
	rpc: NETWORK_URLS,
	bridge: 'https://bridge.walletconnect.org',
	qrcode: true,
})

export const coinbase = new WalletLinkConnector({
	url: `https://rinkeby.infura.io/v3/${INFURA_KEY}`,
	appName: 'Gnarly Goats',
	supportedChainIds: ALL_SUPPORTED_CHAIN_IDS,
})

export const connectorsByName: { [connectorName in ConnectorNames]: any } = {
	[ConnectorNames.Injected]: injected,
	[ConnectorNames.WalletConnect]: walletconnect,
	[ConnectorNames.Coinbase]: coinbase,
}

export const connectorLogosByName: {
	[connectorName in ConnectorNames]: string
} = {
	[ConnectorNames.Injected]: MetaMaskLogo,
	[ConnectorNames.WalletConnect]: WalletConnectLogo,
	[ConnectorNames.Coinbase]: CoinbaseLogo,
}
